"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Overlay = _interopRequireDefault(require("../core/Overlay"));

var _Typeahead = _interopRequireDefault(require("../core/Typeahead"));

var _ClearButton = _interopRequireDefault(require("./ClearButton.react"));

var _Loader = _interopRequireDefault(require("./Loader.react"));

var _TypeaheadInputMulti = _interopRequireDefault(require("./TypeaheadInputMulti.react"));

var _TypeaheadInputSingle = _interopRequireDefault(require("./TypeaheadInputSingle.react"));

var _TypeaheadMenu = _interopRequireDefault(require("./TypeaheadMenu.react"));

var _utils = require("../utils");

var _propTypes2 = require("../propTypes");

var propTypes = {
  /**
   * Specifies the size of the input.
   */
  bsSize: _propTypes.default.oneOf(['large', 'lg', 'small', 'sm']),

  /**
   * Displays a button to clear the input when there are selections.
   */
  clearButton: _propTypes.default.bool,

  /**
   * Props to be applied directly to the input. `onBlur`, `onChange`,
   * `onFocus`, and `onKeyDown` are ignored.
   */
  inputProps: (0, _propTypes2.checkPropType)(_propTypes.default.object, _propTypes2.inputPropsType),

  /**
   * Bootstrap 4 only. Adds the `is-invalid` classname to the `form-control`.
   */
  isInvalid: _propTypes.default.bool,

  /**
   * Indicate whether an asynchronous data fetch is happening.
   */
  isLoading: _propTypes.default.bool,

  /**
   * Bootstrap 4 only. Adds the `is-valid` classname to the `form-control`.
   */
  isValid: _propTypes.default.bool,

  /**
   * Callback for custom input rendering.
   */
  renderInput: _propTypes.default.func,

  /**
   * Callback for custom menu rendering.
   */
  renderMenu: _propTypes.default.func
};
var defaultProps = {
  clearButton: false,
  inputProps: {},
  isInvalid: false,
  isLoading: false,
  isValid: false,
  renderMenu: function renderMenu(results, menuProps, state) {
    return (// TODO: Merged props not registering correctly.
      // $FlowFixMe
      _react.default.createElement(_TypeaheadMenu.default, (0, _extends2.default)({}, menuProps, {
        labelKey: state.labelKey,
        options: results,
        text: state.text
      }))
    );
  }
};

var TypeaheadComponent =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(TypeaheadComponent, _React$Component);

  function TypeaheadComponent() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_instance", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getInstance", function () {
      return _this._instance;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_renderInput", function (inputProps, state) {
      var _this$props = _this.props,
          bsSize = _this$props.bsSize,
          isInvalid = _this$props.isInvalid,
          isValid = _this$props.isValid,
          multiple = _this$props.multiple,
          renderInput = _this$props.renderInput,
          renderToken = _this$props.renderToken;

      if ((0, _utils.isFunction)(renderInput)) {
        return renderInput(inputProps, state);
      }

      var props = (0, _extends2.default)({}, inputProps, {
        bsSize: bsSize,
        isInvalid: isInvalid,
        isValid: isValid
      });
      return multiple ? _react.default.createElement(_TypeaheadInputMulti.default, (0, _extends2.default)({}, props, {
        labelKey: state.labelKey,
        renderToken: renderToken,
        selected: state.selected
      })) : _react.default.createElement(_TypeaheadInputSingle.default, props);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_renderMenu", function (results, menuProps, state) {
      var _this$props2 = _this.props,
          emptyLabel = _this$props2.emptyLabel,
          id = _this$props2.id,
          maxHeight = _this$props2.maxHeight,
          newSelectionPrefix = _this$props2.newSelectionPrefix,
          paginationText = _this$props2.paginationText,
          renderMenu = _this$props2.renderMenu,
          renderMenuItemChildren = _this$props2.renderMenuItemChildren;
      return renderMenu(results, (0, _extends2.default)({}, menuProps, {
        emptyLabel: emptyLabel,
        id: id,
        maxHeight: maxHeight,
        newSelectionPrefix: newSelectionPrefix,
        paginationText: paginationText,
        renderMenuItemChildren: renderMenuItemChildren
      }), state);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_renderAux", function (state) {
      var _this$props3 = _this.props,
          bsSize = _this$props3.bsSize,
          clearButton = _this$props3.clearButton,
          disabled = _this$props3.disabled,
          isLoading = _this$props3.isLoading;
      var onClear = state.onClear,
          selected = state.selected;
      var content;

      if (isLoading) {
        content = _react.default.createElement(_Loader.default, {
          bsSize: bsSize
        });
      } else if (clearButton && !disabled && selected.length) {
        content = _react.default.createElement(_ClearButton.default, {
          bsSize: bsSize,
          onClick: onClear,
          onFocus: function onFocus(e) {
            // Prevent the main input from auto-focusing again.
            e.stopPropagation();
          },
          onMouseDown: _utils.preventInputBlur
        });
      }

      return content ? _react.default.createElement("div", {
        className: (0, _classnames.default)('rbt-aux', {
          'rbt-aux-lg': bsSize === 'large' || bsSize === 'lg'
        })
      }, content) : null;
    });
    return _this;
  }

  var _proto = TypeaheadComponent.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props4 = this.props,
        children = _this$props4.children,
        className = _this$props4.className,
        style = _this$props4.style;
    return _react.default.createElement(_Typeahead.default, (0, _extends2.default)({}, this.props, {
      ref: function ref(instance) {
        return _this2._instance = instance;
      }
    }), function (_ref) {
      var getInputProps = _ref.getInputProps,
          getOverlayProps = _ref.getOverlayProps,
          state = _ref.state;

      var auxContent = _this2._renderAux(state);

      return _react.default.createElement("div", {
        className: (0, _classnames.default)('rbt', {
          'has-aux': !!auxContent
        }, className),
        style: (0, _extends2.default)({
          outline: 'none',
          position: 'relative'
        }, style),
        tabIndex: -1
      }, _this2._renderInput(getInputProps(_this2.props.inputProps), state), _react.default.createElement(_Overlay.default, getOverlayProps(_this2.props), function (menuProps) {
        return _this2._renderMenu(state.results, menuProps, state);
      }), auxContent, (0, _utils.isFunction)(children) ? children(state) : children);
    });
  };

  return TypeaheadComponent;
}(_react.default.Component);

(0, _defineProperty2.default)(TypeaheadComponent, "propTypes", propTypes);
(0, _defineProperty2.default)(TypeaheadComponent, "defaultProps", defaultProps);
var _default = TypeaheadComponent;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap-typeahead/lib/components/Typeahead.react.js
// module id = 353
// module chunks = 0